module.exports = __webpack_public_path__ + "static/media/icon-plus.11fbf5d4.svg";